import {
 Template
} from '../models';

const mapTemplateRelationships = (obj, included) => {
  return Object.keys(obj).flatMap((key) => {
    const item = obj[key];

    return item.data.flatMap((rel) => {
      return included.flatMap((meta) => {
        if (rel.id === meta.id) {
          return {
            type: meta.type,
            field: key,
            component: meta.attributes.field_component,
            source: meta.attributes.field_source,
            location: meta.attributes.field_location
          };
        }
        return [];
      });
    });
  });
};

export const mapTemplates = (result) => {
  return result.data
    .map((item) => {
      return {
        attributes: {
          ...item.attributes,
          relationships: mapTemplateRelationships(item.relationships, result.included)
        }
      };
    })
    .map((template) => {
      return new Template(template).mapToStandard();
    });
};
